<template>
    <div class="VolunteersListPage CatalogPage">
        <div class="container">

            <div class="filters" v-if="$mqAbove('MOBILE')&&data?.filters">
                <div class="row mb-3">
                    <div class="select__input" v-if="data?.filters?.category">
                        <ASelect static-label
                                 label=" "
                                 display="title"
                                 @change="setFilter"
                                 staticLabel
                                 multiple
                                 :placeholder="data.filters.category.placeholder"
                                 :options="data.filters.category.options"
                                 v-model="fieldData.category"
                        >
                            <template #item="item">
                                <div class="flex v-center">
                                    <a-checkbox :label="item.title" v-model="item.selected"/>
                                </div>
                            </template>
                        </ASelect>
                    </div>
<!--                    <div class="col d-3 md-4">
                        <a-date-picker
                            static-label
                            label=" "
                            range
                            :placeholder="'Выберите время'"
                            v-model="fieldData.time"
                        />
                    </div>-->
<!--                    <div class="col d-3 md-4">
                        <ASelect static-label
                                 label=" "
                                 display="title"
                                 :placeholder="params.filters.details.placeholder"
                                 :options="params.filters.details.options"
                                 v-model="fieldData.details"
                        >
                            <template #item="{title}">{{ title }}</template>
                        </ASelect>
                    </div>-->
<!--                    <div class="col d-3 view-mode">
                        <div class="toggleBtn">
                            <Toggle v-model="fieldData.pro"/>
                            <strong>Только PRO</strong>
                        </div>
                    </div>-->
                </div>

                <div class="row">
                    <div class="col d6 selectedFilters">
                      <template v-for="option in data.filters.category.options">
                        <ABadge v-if="option.selected">
                          {{option.title}}
                        </ABadge>
                      </template>
                    </div>
                    <div class="col d6 dropdownFilters">
                        <ADropdown
                            :options="sortOptions"
                            :title="params?.messages?.sortAs"
                            v-model="sort"
                        />
                    </div>
                </div>
            </div>
            <div class="filters--mobile" v-else-if="(data?.filters)">
                <div class="filters--mobileHeading">
                    <span>{{params.messages.filter}}</span>
                    <img src="/local/templates/main/img/icons/filters.svg" alt="" @click="toggleMobileFilters(true)">
                </div>
                <div class="filtersMobileMenu" :class="{'filtersMobileMenu--opened': filtersOpened}">
                    <div class="header__actions-mob flex v-center menu-toggle">
                        <ABtn @click="toggleMobileFilters(false)" :class="{active: true}">
                            <template #content>
                                <div class="icon">
                                    <svg width="20" height="2" viewBox="0 0 20 2" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M20 0H0V2H20V0Z"></path>
                                    </svg>
                                    <svg width="20" height="2" viewBox="0 0 20 2" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M20 0H0V2H20V0Z"></path>
                                    </svg>
                                    <svg width="20" height="2" viewBox="0 0 20 2" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M20 0H0V2H20V0Z"></path>
                                    </svg>
                                </div>
                            </template>
                        </ABtn>
                    </div>

                    <ASelect static-label
                             label=" "
                             display="title"
                             @change="setFilter"
                             staticLabel
                             multiple
                             :placeholder="data.filters.category.placeholder"
                             :options="data.filters.category.options"
                             v-model="fieldData.category"
                    >
                        <template #item="{title}">{{ title }}</template>
                    </ASelect>

<!--                    <a-date-picker
                        static-label
                        label=" "
                        range
                        :placeholder="'Выберите время'"
                        v-model="fieldData.time"
                    />-->
<!--
                    <ASelect static-label
                             label=" "
                             display="title"
                             :placeholder="params.filters.details.placeholder"
                             :options="params.filters.details.options"
                             v-model="fieldData.details"
                    >
                        <template #item="{title}">{{ title }}</template>
                    </ASelect>-->
                </div>
            </div>

            <div class="row mb-4">
                <div class="col d12">
                    <div class="list list--grid">
                        <VolonterCard v-for="volunteer in data.volunteers"
                                      :name="volunteer.name"
                                      :spec="volunteer.spec"
                                      :url="volunteer.url"
                                      :photo="volunteer.photo"
                                      :registration_date="volunteer.registration_date"
                                      :rang="volunteer.rang"
                                      :showRang="volunteer.showRang"
                                      :rating="volunteer.rating"
                                      :projects="volunteer.projects"
                        />
                    </div>
                    <div class="paginationContainer" v-if="data?.pagination">
                        <APagination
                            :perPage="data.pagination.res.pageSize"
                            :current-page="data.pagination.res.pageNumber"
                            :messages="data.pagination.mess"
                            @showMore="addMore"
                            showMore
                            :records="data.pagination.res.elementsCount"
                            :total-pages="data.pagination.res.pageCount"
                            :options="pagenOption"
                        />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {watch, ref, computed, provide} from 'vue';
import Toggle from '@vueform/toggle'
import useFilterControls from "~/composables/useFilterControls";
import {ABtn, ABadge, ASelect, ADatePicker, AExpand, ACheckbox, useAProgressBar} from '~/components/ui'
import VolonterCard from "~/components/cards/VolonterCard";
import InfoCard from "~/components/cards/InfoCard";
import HelpSection from "../../components/sections/HelpSection";
import TopVolontersSection from "../../components/sections/TopVolontersSection";
import ArticlesSection from "../../components/sections/ArticlesSection";
import Subscribe from "../../components/sections/Subscribe";
import ADropdown from "../../components/ui/ADropdown";
import APagination from "../../components/ui/APagination";
import {send} from "../../services/api";


export default {
    name: "VolunteersListPageContainer",
    props: ['params'],
    components: {
        APagination,
        ADropdown,
        Subscribe,
        ArticlesSection,
        TopVolontersSection,
        HelpSection,
        ABtn, ABadge, ASelect, ADatePicker, VolonterCard, InfoCard, AExpand, ACheckbox, Toggle
    },
    setup(props) {
        provide('translates', props.params.messages)
      const {filtersOpened, toggleMobileFilters} = useFilterControls()
      const progress = useAProgressBar();
      const fieldData = ref({pro: false,category:[]});
      for (let index in props.params.filters?.category?.options) {
        if(props.params.filters?.category?.options[index].selected) {
          fieldData.value?.category?.push(props.params.filters.category.options[index]);
        }
      }
      const data = ref(props.params);
      const sortOptions = computed(() => {
          return props.params.sort
      })
      const sort = ref(sortOptions.value.find((element,index) =>{ return element['current']} ).value)
      watch(sort, (value) => {
        if (value) {
          location.href = value;
        }
      })
      const setFilter = () => {
        let cat = [];
        for(let index in fieldData.value.category) {
          if(fieldData.value.category[index].value!=undefined) {
            cat.push(fieldData.value.category[index].value);
          }
        }
        cat = cat.join('-or-');
        if(data.timer) {
          clearTimeout(data.timer);
        }
        data.timer = setTimeout(()=>{
          location.href = props.params.filters.linkTemplate.replace('#VARIABLE#', cat);
        },1500);
      }
      const addMore = async () => {
          progress.show();
          await send(data.value.pagination.res.nextPage, {method: "GET"}, {api:'y'}).then((response) => {
            data.value.volunteers = [...data.value.volunteers, ...response[props.params.responseKey].volunteers];
            data.value.pagination= response[props.params.responseKey].pagination;
            progress.hide();
          });

        };

        const pagenOption = computed(() => {
            let res = data.value.pagination.res;
            res.chunk = 5;
            res.edgeNavigation = false;
            res.hideCount = true;
            res.texts = {};
            return res;
        });

      return {
          pagenOption,
          filtersOpened,
          sortOptions,
          toggleMobileFilters,
          fieldData,
          addMore,
          setFilter,
          data,
          sort
        }
    }
}
</script>

<style scoped lang="scss">
.paginationContainer {
  .padd {
    padding: 25px 0;
  }
}
.VolunteersListPage {
    //@todo to component
    .toggleBtn {
        display: flex;
        gap: 10px;
        font-weight: 600;
        font-size: 14px;
        line-height: 19px;
    }

    .dropdownFilters {
        display: flex;
        justify-content: flex-end;
    }
}

.info{
    padding-top: 140px;
}

::v-deep .section-help.bg {
    background: #fff;
}

.paginationContainer{
    display: flex;
    justify-content: space-between;
    gap: 10px;

    .showMore {
        max-width: 205px;

        @include mobile {
            max-width: 100%;
        }
    }

    ::v-deep .APagination {
        @include mobile {
            /*display: none;*/
        }
    }
}

.select__input {
  margin-left: 1em;
  min-width: 22.7%;
  max-width: 48%;
}
</style>

<style>
:root {
    --toggle-width: 2.5rem;
    --toggle-border: 0;
    --toggle-bg-on: #6367A7
}
</style>

<style src="@vueform/toggle/themes/default.css"></style>
